var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.848 13.496L26.992 5.784H21.208V1.928C21.2064 1.41715 21.0028 0.927674 20.6416 0.566446C20.2803 0.205219 19.7908 0.00158241 19.28 0H1.929C1.41798 0.00131871 0.928244 0.204838 0.566801 0.566094C0.205357 0.927351 0.00158369 1.41698 0 1.928V17.352L1.929 19.28H4.373C4.03441 19.8662 3.8561 20.5312 3.856 21.2081C3.8559 21.885 4.034 22.5501 4.37241 23.1363C4.71082 23.7226 5.1976 24.2095 5.78383 24.548C6.37006 24.8865 7.03506 25.0647 7.712 25.0647C8.38894 25.0647 9.05394 24.8865 9.64017 24.548C10.2264 24.2095 10.7132 23.7226 11.0516 23.1363C11.39 22.5501 11.5681 21.885 11.568 21.2081C11.5679 20.5312 11.3896 19.8662 11.051 19.28H21.729C21.3904 19.8662 21.2121 20.5312 21.212 21.2081C21.2119 21.885 21.39 22.5501 21.7284 23.1363C22.0668 23.7226 22.5536 24.2095 23.1398 24.548C23.7261 24.8865 24.3911 25.0647 25.068 25.0647C25.7449 25.0647 26.4099 24.8865 26.9962 24.548C27.5824 24.2095 28.0692 23.7226 28.4076 23.1363C28.746 22.5501 28.9241 21.885 28.924 21.2081C28.9239 20.5312 28.7456 19.8662 28.407 19.28H30.852V13.496H30.848ZM21.208 13.496V7.716H25.208L28.1 13.5H21.208V13.496Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIco);
export default __webpack_public_path__ + "static/media/truck-ico.9872047567674494f93cf9e42e91cc7c.svg";
export { ForwardRef as ReactComponent };